export function capitalize(s: string) {
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function generateUniqueId(): string {
  return (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase();
}

export function isDef<T>(data: T | undefined): data is T {
  return typeof data !== "undefined";
}

export function isNull(data: any): data is null {
  return data === null;
}

export function itExist<T>(data: T | null | undefined | ''): data is T {
  return isDef(data) && !isNull(data) && data !== '';
}

export function isString(data: any): data is string {
  return typeof data === "string";
}

export const truncateWithEnd = (input: string, threshold = 5) => {
  if (input.length <= threshold) {
    return input;
  }

  const subStrLength = Math.ceil((threshold / 3) + 2);

  return `${input.substring(0, subStrLength)}...${input.substring(input.length - Math.ceil(subStrLength))}`;
};

export function truncate(text: string, length: number, cutAtWordBoundary = true) {
  if (text.length <= length) return text;

  text = text.substr(0, length - 1);
  if (cutAtWordBoundary) {
    text = text.substr(0, text.lastIndexOf(" "));
  }
  return text + '…';
}

export function formatDate(date: Date): string {
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
  const yyyy = date.getFullYear();

  return yyyy + '-' + mm + '-' + dd;
}

export function addDays(refDate: Date, days: number): Date {
  const date = new Date(+refDate);
  date.setDate(date.getDate() + days);
  return date;
}

export function dateToTTL(expiresDate: Date): number {
  const now = new Date();
  return Math.floor((expiresDate.getTime() - now.getTime()) / 1000);
}

export function computeTotalPages(totalItems: number, itemsPerPage: number): number {
  const pages = Math.ceil(totalItems / itemsPerPage);

  return pages === 0 ? 1 : pages;
}

export function contextCodeToLabel(contextCode: string): string {
  switch (contextCode) {
    case 'default':
      return 'Digital Passport';
    case 'country-ru':
      return 'Russian';
    case 'consumer-fashion-app-us':
      return 'Fashion App US';
    case 'consumer-my-account-app':
      return 'My Account';
  }

  return contextCode;
}
